import React from 'react';
import { Route } from 'react-router-dom';

import { lazy } from '@components/common/routeLoading';
import { Path } from '@components/routes/constants';
import { SECTION } from '@hooks/useDocumentTitle/constants';
import { RedirectRoute } from '@components/routes/redirect';

const BotBlockingPage = lazy(
  () => import(/* webpackChunkName: "botManagement" */ '@components/botManagement'),
);

/**
 * Registered on the data router (see @components/routes/authorizedRoutes) rather
 * than rendered as a descendant <Routes> block, so each route is matched by the
 * router that answers useMatches() and can carry `handle` metadata.
 *
 * The parent route supplies the path prefix; children stay relative, as they
 * were under the old splat mount.
 */
export const botManagementRoutes = (
  <Route
    key={Path.BOT_MANAGEMENT}
    path={Path.BOT_MANAGEMENT}
    handle={{ section: SECTION.botManagement }}
  >
    <Route index element={<BotBlockingPage />} />
    <Route path="*" element={<RedirectRoute />} />
  </Route>
);
